<tt-page *ngIf="!!itemsListBaseCurrencies">
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListBaseCurrencies"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListBaseCurrencies" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
